// extracted by mini-css-extract-plugin
export default {"index":"ProjectCheckpointCard_index__SEeX1"};